import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { termsList } from '../types';

export const getTermsList = async (): Promise<termsList> => {
  const response = await axios.get(`/api/v1/user/userTerm`, {
})
  //return response?.data;
   const data = response.data;
  return data;
};

type QueryFnType = typeof getTermsList;

type UseTermsListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useTermsList = ({  config }: UseTermsListOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['data'],
    queryFn: () => getTermsList(),
    ...config,
  });
};